import { Asset } from "callable-data-objects";
import SimpleListSearch from "Components/Shared/SimpleListSearch";
import { useAsset } from "Hooks/Endpoints";
import React, { Fragment, useState } from "react";
import { Button, Table } from "semantic-ui-react";

const AssetList = () => {
  const { assets, select, create } = useAsset();

  console.log("AssetView ", assets);
  const [search, setSearch] = useState("");
  const filteredAssets = assets.filter(
    (a: Asset) => a.name.indexOf(search) > -1
  );
  return (
    <Fragment>
      <SimpleListSearch
        title='Assets'
        createText='Create Asset'
        searchPlaceholder='Search'
        onCreate={create}
        onSearch={setSearch}
        text={search}
      />
      <Table celled padded stackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Filename</Table.HeaderCell>
            <Table.HeaderCell>Mime Type</Table.HeaderCell>
            <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {filteredAssets.map((asset: Asset) => (
            <Table.Row>
              <Table.Cell>{asset.name}</Table.Cell>
              <Table.Cell>{asset.mimeType}</Table.Cell>
              <Table.Cell textAlign='right'>
                <Button primary size='tiny' onClick={() => select(asset.id)}>
                  View
                </Button>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </Fragment>
  );
};

export default AssetList;
